function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Enrichment_svg__5_a",
  x1: "0%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4F9FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F8E7FF"
})), React.createElement("linearGradient", {
  id: "Enrichment_svg__6_b",
  x1: "0%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DFE",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#B97AD3",
  stopOpacity: 0.2
})), React.createElement("linearGradient", {
  id: "Enrichment_svg__7_c",
  x1: "0%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#D576F0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Enrichment_svg__5_a)",
  stroke: "url(#Enrichment_svg__6_b)",
  d: "M8 .5A7.5 7.5 0 00.5 8v34A7.5 7.5 0 008 49.5h34a7.5 7.5 0 007.5-7.5V8A7.5 7.5 0 0042 .5H8z"
}), React.createElement("path", {
  fill: "url(#Enrichment_svg__7_c)",
  d: "M9.523 0h6.954c3.311 0 4.512.345 5.723.992A6.75 6.75 0 0125.008 3.8c.647 1.21.992 2.412.992 5.723v6.954c0 3.311-.345 4.512-.992 5.723a6.75 6.75 0 01-2.808 2.808c-1.21.647-2.412.992-5.723.992H9.523c-3.311 0-4.512-.345-5.723-.992A6.75 6.75 0 01.992 22.2C.345 20.99 0 19.788 0 16.477V9.523C0 6.212.345 5.011.992 3.8A6.75 6.75 0 013.8.992C5.01.345 6.212 0 9.523 0zm7.761 5.023h1.85c.707 0 .952.047 1.203.181.2.107.352.26.459.459.134.251.181.496.181 1.204v1.849a.739.739 0 001.478 0v-1.85c0-.93-.092-1.405-.357-1.9a2.569 2.569 0 00-1.064-1.064c-.495-.265-.97-.357-1.9-.357h-1.85a.739.739 0 100 1.478zm3.693 12.261v1.85c0 .707-.047.952-.181 1.203-.107.2-.26.352-.459.459-.251.134-.496.181-1.204.181h-1.849a.739.739 0 000 1.478h1.85c.93 0 1.405-.092 1.9-.357.457-.244.82-.607 1.064-1.064.265-.495.357-.97.357-1.9v-1.85a.739.739 0 00-1.478 0zM8.716 20.977h-1.85c-.707 0-.952-.047-1.203-.181a1.092 1.092 0 01-.459-.459c-.134-.251-.181-.496-.181-1.204v-1.849a.739.739 0 10-1.478 0v1.85c0 .93.092 1.405.357 1.9.244.457.607.82 1.064 1.064.495.265.97.357 1.9.357h1.85a.739.739 0 000-1.478zM5.023 8.716v-1.85c0-.707.047-.952.181-1.203.107-.2.26-.352.459-.459.251-.134.496-.181 1.204-.181h1.849a.739.739 0 100-1.478h-1.85c-.93 0-1.405.092-1.9.357-.457.244-.82.607-1.064 1.064-.265.495-.357.97-.357 1.9v1.85a.739.739 0 101.478 0zm2.568 3.102h10.818a.5.5 0 01.5.5v1.364a.5.5 0 01-.5.5H7.591a.5.5 0 01-.5-.5v-1.364a.5.5 0 01.5-.5zm1.182-4.727h8.454a.5.5 0 01.5.5v1.364a.5.5 0 01-.5.5H8.773a.5.5 0 01-.5-.5V7.59a.5.5 0 01.5-.5zm0 9.454h8.454a.5.5 0 01.5.5v1.364a.5.5 0 01-.5.5H8.773a.5.5 0 01-.5-.5v-1.364a.5.5 0 01.5-.5z",
  transform: "translate(12 12)"
}));

var SvgEnrichment = function SvgEnrichment(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgEnrichment;